module.exports = __webpack_public_path__ + "static/shapes-272113dd4800251c60df3e30c62b20ed.png";